<template>
  <div class="wrapper">
    <p class="title">
      {{ detail.title || (detail.details && detail.details.title) }}
    </p>
    <p class="date">
      {{ detail.en_title || (detail.details && detail.details.create_time) }}
    </p>
    <div
      class="rich"
      v-html="detail.content || (detail.details && detail.details.content)"
    ></div>

    <div class="news-more" v-if="detail.details">
      <p class="title pc">
        <span>上一篇</span>
        <span>下一篇</span>
      </p>
      <div class="down pc">
        <router-link
          v-if="detail.up"
          tag="div"
          :to="{ path: '/detail', query: { api, id: detail.up.id } }"
        >
          <img :src="detail.up.img" alt="" />
          <p class="d-date">{{ detail.up.create_time }}</p>
          <p class="d-title">{{ detail.up.title }}</p>
        </router-link>
        <span v-else>没有上一篇</span>
        <router-link
          v-if="detail.down"
          tag="div"
          :to="{ path: '/detail', query: { api, id: detail.down.id } }"
          ><img :src="detail.down.img" alt="" />
          <p class="d-date">{{ detail.down.create_time }}</p>
          <p class="d-title">{{ detail.down.title }}</p></router-link
        >
        <span v-else>没有下一篇</span>
      </div>
      <p class="title mobile">上一篇</p>
      <div class="down mobile">
        <router-link
          v-if="detail.up"
          tag="div"
          :to="{ path: '/detail', query: { api, id: detail.up.id } }"
        >
          <img :src="detail.up.img" alt="" />
          <p class="d-date">{{ detail.up.create_time }}</p>
          <p class="d-title">{{ detail.up.title }}</p>
          <p class="d-intro">{{ detail.up.intro }}</p>
        </router-link>
        <span v-else class="d-title-b">没有上一篇</span>
      </div>
      <p class="title mobile">下一篇</p>
      <div class="down mobile">
        <router-link
          v-if="detail.down"
          tag="div"
          :to="{ path: '/detail', query: { api, id: detail.down.id } }"
        >
          <img :src="detail.down.img" alt="" />
          <p class="d-date">{{ detail.down.create_time }}</p>
          <p class="d-title">{{ detail.down.title }}</p>
          <p class="d-intro">{{ detail.down.intro }}</p>
        </router-link>
        <span v-else class="d-title-b">没有下一篇</span>
      </div>
    </div>
    <p class="back" v-else>
      <span @click="$router.back()">返回</span>
    </p>
  </div>
</template>

<script>
import { server_details, news_details, cases_details } from '../utils/api'
let apis = {
  server_details,
  news_details,
  cases_details,
}
export default {
  data() {
    return {
      detail: {},
      query: {},
      api: '',
    }
  },
  watch: {
    '$route.query.id': {
      handler() {
        location.reload()
      },
      deep: true,
    },
  },
  created() {
    let query = this.$route.query
    this.api = query.api
    delete query.api
    this.query = query
    this.getData()
  },
  methods: {
    getData() {
      console.log(1.1)
      apis[this.api].call(this, this.query, (r) => {
        this.detail = r.data
        console.log(r.data)
        this.$set(this, 'detail', r.data)
      })
    },
  },
}
</script>

<style lang='less' scoped>
.wrapper {
  background: #ffffff;
  box-shadow: 0px 3px 36px rgba(0, 0, 0, 0.1);
  padding: 40px;
  box-sizing: border-box;
  margin: 80px auto;
  
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1a1a1a;
    text-align: center;
    line-height: 31px;
  }
  .date {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909090;
    padding-top: 10px;
    padding-bottom: 20px;
    border-bottom: 1px solid #1a1a1a;
    margin-bottom: 20px;
    text-align: center;
    word-break: break-all;
  }
}
p.back {
  text-align: center;
  margin-top: 39px;
  span {
    width: 120px;
    height: 40px;
    background: #006C8F;
    opacity: 1;
    border-radius: 20px;
    display: inline-block;
    line-height: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
}
.news-more {
  margin-top: 80px;
  .title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #1a1a1a;
    display: flex;
    justify-content: space-between;
    padding-bottom: 17px;
    border-bottom: 1px solid black;
  }
  .down {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    div {
      cursor: pointer;
      width: 560px;
      img {
        width: 560px;
        height: 342px;
        margin-bottom: 19px;
        vertical-align: middle;
      }
      .d-date {
        font-size: 14px;
        font-family: DIN;
        font-weight: 400;
        line-height: 17px;
        color: #909090;
        margin-bottom: 20px;
      }
      .d-title {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 29px;
        color: #04131a;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
@media (max-width: 767px) {
  .wrapper {
    padding: 0.34rem;
    width: calc(100% - 0.68rem);
    margin: 0.34rem auto;
    margin-top: 1.22rem;
    overflow-x: hidden;
    .title {
      font-size: 0.32rem;
    }
    .date {
      font-size: 0.24rem;
      padding-top: 0.12rem;
      padding-bottom: 0.24rem;
    }
  }
  .d-title-b {
    font-size: 0.24rem;
    margin-bottom: 0.68rem;
  }
  .news-more {
    margin-top: 0.68rem;
    .down {
      margin-top: 0.34rem;
      div {
        position: relative;
        padding-left: 2.84rem;
        height: 2.5rem;
        width: 100%;
        box-sizing: border-box;
        img {
          width: 2.5rem;
          height: 2.5rem;
          object-fit: cover;
          position: absolute;
          left: 0;
          top: 0;
          margin-bottom: 0;
        }
        .d-date {
          font-size: 0.2rem;
          margin-bottom: 0.24rem;
        }
        .d-title {
          font-size: 0.32rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .d-intro {
          font-size: 0.28rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 0.48rem;
          color: #909090;
          margin-top: 0.24rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>